import { Halflogoicon, NoSearchResult } from "assests";

const ResultNotFound = ({ text = false }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center max-w-[600px]  mx-auto w-full  rounded-xl bg-white ${text ? "p-6" : "p-8 my-12"}`}
    >
      <div className={`flex flex-col items-center justify-center  ${text ? "gap-2" : "gap-6"}`}>
        <div className="flex items-center justify-center ">
          <div
            className={`bg-white flex items-center justify-center  border border-global-gray-soft w-14 h-14 rounded-xl`}
            style={{
              boxShadow:
                "rgba(16, 24, 40, 0.05) 0px 1px 2px 0px, rgba(1, 24, 50, 0.06) 0px 0px 0px .5px inset, rgba(16, 24, 40, 0.05) 0px -2px 0px 0px inset",
            }}
          >
            <Halflogoicon width={28} height={26} />
          </div>
        </div>

        <p className="text-lg font-semibold  leading-[38px] text-gray-950">
          {text ? text : "Result not found. Please search again"}
        </p>
      </div>
    </div>
  );
};

export default ResultNotFound;
